import { normalizeDeviceHardware } from "./device-hardware-utils";
import { NormalizedDeviceHardware } from "../data/device-hardware";
export function isDeviceLocated(device) {
    return device.location !== undefined;
}
export function isDevicePaired(device) {
    return device.asset !== undefined;
}
/**
 * Checks if the given asset has a device,
 * and resolves it as a {@link PairedVelavuAsset}
 */
export function isAssetPaired(asset) {
    return asset.device_id !== undefined;
}
/**
 * Returns whether a device is a Vesta device
 */
export function isDeviceVesta(device) {
    if (device === undefined) {
        return false;
    }
    return normalizeDeviceHardware(device.hardware) === NormalizedDeviceHardware.Argo;
}
/**
 * Returns whether a device is an Arda device
 */
export function isDeviceArda(device) {
    if (device === undefined) {
        return false;
    }
    return normalizeDeviceHardware(device.hardware) === NormalizedDeviceHardware.Juno;
}
/**
 * Returns whether a device is a Pavo device
 */
export function isDevicePavo(device) {
    if (device === undefined) {
        return false;
    }
    return normalizeDeviceHardware(device.hardware) === NormalizedDeviceHardware.Meridian;
}
/**
 * Returns whether a device is a gateway
 */
export function isDeviceGateway(device) {
    return isDeviceVesta(device);
}
//# sourceMappingURL=device-utils.js.map